/**
 * Created by neo on 10.05.21.
 */
import { makeAutoObservable } from 'mobx';
import { Audited, createAuditedFields } from '../../Audited';
import { Media, createMedia } from '../../Media/Media';

export type TtsCacheResponse = Audited & {
  identifier: string;
  ttsId: string;
  variableValues: Record<string, string>;
  media: Media;
  matchesVariables(variables: Record<string, string>): boolean;
};

export function createTtsCacheResponse(json?: Partial<TtsCacheResponse>): TtsCacheResponse {
  const base = createAuditedFields(json);
  return makeAutoObservable({
    ...base,
    identifier: json?.identifier ?? '',
    ttsId: json?.ttsId ?? '',
    variableValues: json?.variableValues ?? {},
    media: createMedia(json?.media),

    matchesVariables(variables: Record<string, string>): boolean {
      const keysObject1 = Object.keys(variables);
      const keysObject2 = Object.keys(this.variableValues);

      if (keysObject1.length !== keysObject2.length) {
        return false;
      }

      for (const key of keysObject1) {
        if (variables[key] !== this.variableValues[key]) {
          return false;
        }
      }

      return true;
    },
  });
}
